import axios from 'axios'
import router from './router'
import store from './store'
import Swal from 'sweetalert2'
import baseUrl from './config'

const instance = axios.create({
   //baseURL: 'http://api.hova.co.il/api/',
   baseURL: baseUrl.data(),
   headers: {
     'Content-Type': 'application/json',
     "Access-Control-Allow-Origin": "*"
   }
})

export default instance

// Add Authorization header only if token exists and not for login endpoint
instance.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem('token');
    // Don't add Authorization for login endpoint
    if (token && !(config.url && config.url.includes('/login'))) {
      config.headers['Authorization'] = `Bearer ${token}`;
    } else {
      delete config.headers['Authorization'];
    }
    
    // Add X-CRM-Source header for all requests
    const modeSource = localStorage.getItem('modeSource') || 'hova';
    config.headers['X-CRM-Source'] = modeSource;
    
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// https://www.techynovice.com/setting-up-JWT-token-refresh-mechanism-with-axios/
instance.interceptors.response.use(
  function (response) {
    // If the request succeeds, we don't have to do anything and just return the response
    return response
  },
  function (error) {
    const errorResponse = error.response
    if (isTokenExpiredError(errorResponse)) {
      Swal.fire({
        title: 'Please log in again!',
        confirmButtonText: 'Login',//'<a href="/login">Login</a>',
        onClose: () => {
          router.replace('/login')
          store.dispatch('logout')
        }
      })

    }
    return Promise.reject(error)
  }
)

function isTokenExpiredError (errorResponse) {
  return errorResponse && errorResponse.status === 401 // unauthorized
}

